import React, { FC } from "react";

import { GenericEventView, testIds, useEvent } from "@events";
import { Col, Row, Typography } from "@ctra/components";

const { Text } = Typography;

/**
 * Custom Event View component
 * @constructor
 */
export const GamePlanTaskEventView: FC<{ open?: boolean }> = (props) => {
  const { getDescription } = useEvent();

  return (
    <GenericEventView {...props}>
      <Row data-testid={testIds.entity.entry.description}>
        <Col flex={1}>
          <Text italic>{getDescription()}</Text>
        </Col>
      </Row>
    </GenericEventView>
  );
};
